"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
var Role;
(function (Role) {
    Role["User"] = "User";
    Role["Assistant"] = "Assistant";
})(Role || (exports.Role = Role = {}));
